import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Audience paths — who the product serves day-to-day.
 * Intentionally not Purpose / Vision / Mission (those live on About).
 */
function AudienceSection() {
  const audiences = [
    {
      title: 'Founders',
      body: 'Looking for a co-founder who complements your skills and shares the grind.',
      to: '/search',
      label: 'Explore profiles',
    },
    {
      title: 'Builders & talent',
      body: 'Ready to join an early team where your work shapes the product.',
      to: '/startup-jobs',
      label: 'See open roles',
    },
    {
      title: 'Hiring teams',
      body: 'Post roles, reach candidates, and get optional recruitment support when you need it.',
      to: '/post-job',
      label: 'Post a job',
    },
    {
      title: 'Capital explorers',
      body: 'Surface investor conversations and opportunities alongside your founding journey.',
      to: '/feed',
      label: 'Join the feed',
    },
  ];

  return (
    <section className="home-audience" id="for-you">
      <div className="home-section-inner">
        <header className="home-section-head ch-reveal">
          <h2>Made for the people building startups</h2>
          <p>
            Pick your path — CofounderHubs is the shared ground where those journeys meet.
          </p>
        </header>
        <div className="home-audience-grid ch-stagger">
          {audiences.map((item) => (
            <Link key={item.title} to={item.to} className="home-audience-link ch-reveal">
              <h3>{item.title}</h3>
              <p>{item.body}</p>
              <span>{item.label} →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AudienceSection;
